import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { IdType } from '../nav-links/models/nav-links.enums';
import {
  NavigationUIMenuKeys,
  PrimaryNavActionEvent,
  SecondaryNavActionEvent
} from '../nav-links/models/nav-links.interfaces';
import { SecondaryLinksSEO } from '../secondary-links-seo/models/secondary-links-seo.interfaces';
import { SecondaryLinksSeoComponent } from '../secondary-links-seo/secondary-links-seo.component';
import { MobileNavItemLinks } from './models/mobile-nav-links.interfaces';

@Component({
  selector: 'idp-mobile-nav-links',
  standalone: true,
  imports: [CommonModule, SecondaryLinksSeoComponent],
  templateUrl: './mobile-nav-links.component.html',
  styleUrls: ['./mobile-nav-links.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MobileNavLinksComponent {
  @Input() content: MobileNavItemLinks = {} as MobileNavItemLinks;
  @Input() secondaryContent: SecondaryLinksSEO = {} as SecondaryLinksSEO;
  @Input() selectedNav!: string | null;
  @Input() highlightOnlyFirstItem!: boolean;
  @Input() isMobileDevice!: boolean;
  @Input() isMenuOpen = false;
  @Input() isAlertAdvisory = false;
  @Input() isBusiness = false;
  @Input() collapsedHeader = false;
  @Input() viewSearchOptionExpanded = false;
  @Output() primaryNavAction = new EventEmitter<PrimaryNavActionEvent>();
  @Output() secondaryNavAction = new EventEmitter<SecondaryNavActionEvent>();
  @Output() analyticsEvent = new EventEmitter<{
    id: NavigationUIMenuKeys;
    label?: string;
  }>();

  selectedNavItem(
    widgetId: string,
    redirectMobile: boolean,
    redirectMobileUrl = ''
  ): void {
    if (this.checkMobileAndRedirectUrl(redirectMobile, redirectMobileUrl)) {
      window.location.href = redirectMobileUrl;
      return;
    }

    this.selectedNav = widgetId;
    this.primaryNavAction.emit({
      id: widgetId
    });
  }

  checkMobileAndRedirectUrl(
    redirectMobile: boolean,
    redirectMobileUrl: string
  ): boolean {
    return this.isMobileDevice && redirectMobile && redirectMobileUrl !== '';
  }

  onSecondaryNavActionToggle(id: string): void {
    this.secondaryNavAction.emit({
      type: 'click',
      secondaryId: id,
      id: IdType.SECONDARY
    });
  }

  onTrackingObject(id: string, label?: string): void {
    const selectedId = id as NavigationUIMenuKeys;
    this.analyticsEvent.emit({ id: selectedId, label: label });
  }
}
